var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicOff1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 56,
    viewBox: "0 0 43 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4453 10.5C11.4453 4.97715 15.9225 0.5 21.4453 0.5C26.9681 0.5 31.4453 4.97715 31.4453 10.5V28C31.4453 33.5228 26.9681 38 21.4453 38C15.9225 38 11.4453 33.5228 11.4453 28V10.5Z",
    fill: "#F44336"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.07031 27.6094V27.9999C7.07031 31.8124 8.58481 35.4686 11.2807 38.1646C13.9765 40.8604 17.6328 42.3749 21.4453 42.3749C25.2578 42.3749 28.9141 40.8604 31.6101 38.1646C34.3058 35.4686 35.8203 31.8124 35.8203 27.9999V27.6094C35.8203 26.2286 36.9396 25.1094 38.3203 25.1094H39.5703C40.9511 25.1094 42.0703 26.2286 42.0703 27.6091V27.9999C42.0703 33.4699 39.8973 38.7161 36.0293 42.5839C32.9058 45.7076 28.8836 47.7256 24.5703 48.3869V52.9999C24.5703 54.3806 23.4511 55.4999 22.0703 55.4999H20.8203C19.4396 55.4999 18.3203 54.3806 18.3203 52.9999V48.3869C14.0071 47.7256 9.98479 45.7076 6.86124 42.5839C2.99329 38.7161 0.820312 33.4699 0.820312 27.9999V27.6094C0.820312 26.2286 1.93961 25.1094 3.32031 25.1094H4.57031C5.95101 25.1094 7.07031 26.2286 7.07031 27.6094Z",
    fill: "#F44336"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicOff1);
export default __webpack_public_path__ + "static/media/mic-off (1).ada598fae2abd83149db74d63bf721bf.svg";
export { ForwardRef as ReactComponent };